import { Api } from "@cms/cms-api";

export const cmsClient = new Api({
    baseUrl: import.meta.env.VITE_CMS_API_URL,
});

cmsClient.v1.getMainModuleCollectionDetail